import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty, isNaN, map, isEqual } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import uuid from 'uuid/v1';

import { Stack, Box } from '@mui/material';
import {
  renderIconButton,
  renderButton,
  renderTextField,
  renderSwitch
} from '../../MaterialMUIComponent';

import { URL_REGEX, YOUTUBE_URL_REGEX } from '../../../../api/Videos/Videos';

import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';

import UploadFileComponent from '../../UploadFileComponent/UploadFileComponent';
import OpenModalFromUrl from '../../OpenModalFromUrl/index';

const TemplateButtonItem = ({
  elementItem,
  updateAnnotationFields,
  isAdvancedMode,
  previewMode,
  viewBasicEditMultis
}) => {
  const isPreview = isEqual(previewMode, 'preview');
  const [propSharedMAP, setPropSharedMap] = React.useState({ zoom: 0, lat: 'none', lng: 'none' });
  const [urlMapSharedState, setUrlMapSharedState] = React.useState('none');
  const [openFullScreen, setOpenFullScreen] = React.useState(false);
  const isSharedMap =
    !isEqual(urlMapSharedState, 'none') &&
    !isEqual(propSharedMAP.lat, 'none') &&
    !isEqual(propSharedMAP.lng, 'none');

  const handleLink = url => {
    const isValid = YOUTUBE_URL_REGEX.test(url) || URL_REGEX.test(url);
    if (isValid) {
      const existCoords = url.includes('lng=') && url.includes('&lat=');
      if (existCoords) {
        const urlMapShared = url.substring(0, url.lastIndexOf('/') + 1);
        const subStringCoords = url.substring(url.lastIndexOf('/') + 1);
        const lngString = subStringCoords.substring(
          subStringCoords.indexOf('=') + 1,
          subStringCoords.indexOf('&')
        );
        const latString = subStringCoords.substring(
          subStringCoords.indexOf('lat') + 4,
          subStringCoords.lastIndexOf('&')
        );
        const zoomString = subStringCoords.substring(subStringCoords.lastIndexOf('=') + 1);
        setPropSharedMap({ zoom: Number(zoomString), lat: latString, lng: lngString });
        setUrlMapSharedState(urlMapShared);
      }
      updateAnnotationFields(elementItem, 'hiperLink', url);
    } else Bert.alert('The url of map shared is not valid', 'danger');
  };

  const handlePropsSharedMap = ({ zoom, lat, lng }) => {
    if (!isEmpty(urlMapSharedState)) {
      const latIsNumber = !isNaN(Number(lat));
      const lngIsNumber = !isNaN(Number(lng));
      const zoomIsNumber = !isNaN(Number(zoom));
      if (latIsNumber && lngIsNumber && zoomIsNumber) {
        const newLocationLink = `lng=${lng}&lat=${lat}&zoom=${zoom}`;
        const newUrl = urlMapSharedState + newLocationLink;
        setPropSharedMap({ zoom: Number(zoom), lat, lng });
        updateAnnotationFields(elementItem, 'hiperLink', newUrl);
      } else Bert.alert('Coodinates or zoom not valid', 'danger');
    }
  };

  const renderManyTextField = array =>
    map(array, (item, index) => (
      <Box
        key={`box-textfield-${item.value}-${index}`}
        sx={{
          display: 'flex',
          mb: 2,
          width: '100%'
        }}
      >
        {renderTextField({
          key: item.value || uuid(),
          type: item.type,
          label: item.label,
          style: { ...item.style },
          moreProps: {
            fullWidth: true,
            defaultValue: item.value,
            onBlur: event => item.function(event),
            ...item.moreProps
          }
        })}
      </Box>
    ));

  const renderManyIconButtons = array =>
    map(
      array,
      item =>
        item.isShow &&
        renderIconButton({
          key: uuid(),
          onClick: item.function,
          icon: item.icon,
          titleTooltip: item.title,
          disabled: false,
          style: {
            maxWidth: '38px',
            maxHeight: '38px',
            padding: 0,
            color: item.color || '#2A3F90',
            ...item.style
          }
        })
    );

  const commonIconsPosition = ({ keyValue, isLabelName = true }) => {
    const positionValue = isLabelName
      ? templateOps.getElemenPositionLabelName(elementItem)
      : templateOps.getElemenPosition(elementItem);
    const iconsPosition = [
      {
        function: () => updateAnnotationFields(elementItem, keyValue, 'flex-start'),
        icon: <FontAwesomeIcon icon="align-left" />,
        title: 'Align left',
        disabled: false,
        color: positionValue === 'flex-start' ? 'green' : '#2A3F90',
        isShow: true,
        style: { marginLeft: '2%' }
      },
      {
        function: () => updateAnnotationFields(elementItem, keyValue, 'center'),
        icon: <FontAwesomeIcon icon="align-justify" />,
        title: 'Center',
        disabled: false,
        color: positionValue === 'center' ? 'green' : '#2A3F90',
        isShow: true,
        style: { marginLeft: '2%' }
      },
      {
        function: () => updateAnnotationFields(elementItem, keyValue, 'flex-end'),
        icon: <FontAwesomeIcon icon="align-right" />,
        title: 'Align right',
        disabled: false,
        color: positionValue === 'flex-end' ? 'green' : '#2A3F90',
        isShow: true,
        style: { marginLeft: '2%' }
      }
    ];

    return renderManyIconButtons(iconsPosition);
  };

  return (
    <>
      {!isAdvancedMode && (
        <>
          {!isPreview && viewBasicEditMultis && (
            <UploadFileComponent
              linkValueProp={templateOps.getElementHiperLink(elementItem)}
              handleValueLink={handleLink}
            />
          )}
          {isPreview && !isEmpty(templateOps.getElementHiperLink(elementItem)) && (
            <Box display="flex" justifyContent={templateOps.getElemenPosition(elementItem)}>
              {renderButton({
                key: 'buttonItem',
                onClick: templateOps.getElemenFullScreenEnv(elementItem)
                  ? () => setOpenFullScreen(true)
                  : () => window.open(templateOps.getElementHiperLink(elementItem)),
                contentButton: isEmpty(templateOps.getElementValue(elementItem))
                  ? 'Open Link'
                  : templateOps.getElementValue(elementItem),
                style: {
                  height: `${templateOps.getElementHeight(elementItem)}% `,
                  width: `${templateOps.getElementWidth(elementItem)}% `
                },
                moreProps: {
                  variant: 'link',
                  target: '_blank',
                  rel: 'noreferrer noopener'
                }
              })}
              <OpenModalFromUrl
                isFullScreen
                isImage={false}
                openModal={openFullScreen}
                setOpenModal={setOpenFullScreen}
                url={templateOps.getElementHiperLink(elementItem)}
              />
            </Box>
          )}
        </>
      )}
      {isAdvancedMode && (
        <>
          <Stack direction="row" display="flex">
            {renderSwitch({
              checked: templateOps.getElemenFullScreenEnv(elementItem),
              onChange: () => {
                updateAnnotationFields(
                  elementItem,
                  'fullScreenIpsilumEnv',
                  !templateOps.getElemenFullScreenEnv(elementItem)
                );
              },
              labelCheck: 'Inside Ipsilum',
              labelUncheck: 'New Window'
            })}
            {commonIconsPosition({
              keyValue: 'positionElement',
              isLabelName: false
            })}
          </Stack>
          <UploadFileComponent
            linkValueProp={templateOps.getElementHiperLink(elementItem)}
            handleValueLink={handleLink}
          />
          <Stack
            direction="row"
            width="95%"
            height="100%"
            display="flex"
            justifyContent="space-around"
          >
            {renderManyTextField([
              {
                type: 'text',
                label: 'Text button',
                value: isEmpty(templateOps.getElementValue(elementItem))
                  ? 'Open Link'
                  : templateOps.getElementValue(elementItem),
                function: event => updateAnnotationFields(elementItem, 'value', event.target.value)
              },
              {
                type: 'number',
                label: 'Height button (%)',
                value: templateOps.getElementHeight(elementItem),
                function: event =>
                  updateAnnotationFields(elementItem, 'height', Number(event.target.value))
              },
              {
                type: 'number',
                label: 'Width button (%)',
                value: templateOps.getElementWidth(elementItem),
                function: event =>
                  updateAnnotationFields(elementItem, 'width', Number(event.target.value))
              }
            ])}
          </Stack>
          {isSharedMap && (
            <Stack
              direction="row"
              width="100%"
              height="100%"
              display="flex"
              justifyContent="space-around"
            >
              {renderManyTextField([
                {
                  type: 'text',
                  label: 'Lat',
                  value: propSharedMAP.lat,
                  function: event =>
                    handlePropsSharedMap({ ...propSharedMAP, lat: event.target.value })
                },
                {
                  type: 'text',
                  label: 'Lng',
                  value: propSharedMAP.lng,
                  function: event =>
                    handlePropsSharedMap({ ...propSharedMAP, lng: event.target.value })
                },
                {
                  type: 'number',
                  label: 'Zoom',
                  value: propSharedMAP.zoom,
                  function: event =>
                    handlePropsSharedMap({ ...propSharedMAP, zoom: Number(event.target.value) })
                }
              ])}
            </Stack>
          )}
        </>
      )}
    </>
  );
};
TemplateButtonItem.defaultProps = {
  updateAnnotationFields: () => {}
};
TemplateButtonItem.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func,
  isAdvancedMode: PropTypes.bool.isRequired,
  previewMode: PropTypes.string.isRequired,
  viewBasicEditMultis: PropTypes.bool.isRequired
};
export default TemplateButtonItem;
